<template>
  <div>
    <!-- <v-app-bar class="mt-10" dense elevation="0" color="transparent">
      <v-spacer />
      <v-chip class="mx-1" label dense
        >student No:<v-divider class="mx-1" inset vertical />
        {{ bioData !== null ? bioData.studentNo : "" }}</v-chip
      >
      <v-chip label class="mx-1"
        >Profile ID <v-divider class="mx-1" inset vertical />{{
          bioData !== null ? bioData.profileID : ""
        }}</v-chip
      >
      <v-chip
        label
        dense
        class="mx-1"
        :color="bioData.activated ? 'primary' : 'red darken-1'"
      >
        {{ bioData.activated ? "Active" : "Inactive" }}
      </v-chip>
    </v-app-bar> -->
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "profileComponent",
  data() {
    return {
      chip3: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch("Profile/getAllSetup");
      window.document.title = "KISEB::My Profile";
    });
  },
  computed: {
    bioData() {
      return this.$store.getters["Profile/bioData"];
    },
  },
  methods: {},
};
</script>

<style scoped></style>
